import { createReducer, on } from "@ngrx/store";
import { initialState } from "../privacy.state";
import {
  loadAcceptTerms,
  acceptTermsFailure,
  acceptTermsSuccess,
  loadTerms,
  loadTermsFailure,
  loadTermsSuccess,
} from "../actions/privacy.actions";
import { PrivacyState } from "../../interfaces/privacy-state.interface";

export const privacyReducer = createReducer(
  initialState,
  on(
    loadAcceptTerms,
    (state): PrivacyState => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    acceptTermsSuccess,
    (state, { response }): PrivacyState => ({
      ...state,
      isLoading: false,
      error: null,
      success: true,
      terms: [
        {
          ...state.terms[0],
          status: "ACCEPTED",
        },
      ],
    }),
  ),
  on(
    acceptTermsFailure,
    (state, { error }): PrivacyState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
  on(
    loadTerms,
    (state): PrivacyState => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    loadTermsSuccess,
    (state, { terms }): PrivacyState => ({
      ...state,
      terms,
    }),
  ),
  on(
    loadTermsFailure,
    (state, { error }): PrivacyState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
);
